// @flow
import FeatureFlagContainer from './FeatureFlagContainer';

export type { IFeatureFlagContainer } from './FeatureFlagContainer';
export default FeatureFlagContainer;
